import { pluralize } from "@wrstudios/utils";
import PropTypes from "prop-types";
import React from "react";
import IllustrationComps from "../../illustrations/IllustrationComps";
import { useLive } from "../LiveProvider";
import Preview from "./LivePreview";

function LivePreviewComps({ title }) {
  const { visibleListings } = useLive();

  return (
    <Preview
      illustration={<IllustrationComps />}
      title={title}
      subTitle={pluralize("Comparable Homes", visibleListings.length, true)}
    />
  );
}

LivePreviewComps.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewComps;
